import React from 'react';
import {motion} from 'framer-motion';
import {cn} from '@/lib/utils';

const PHRASES = [
    "Cooking your video with AI",
    "Bedazzling every frame",
    "Teaching pixels new tricks",
    "Balancing color, motion & mood",
    "Stitching scenes into a story",
    "Polishing the lens",
    "Applying cinematic magic",
    "Rendering your masterpiece"
];

const FilmFrame = ({text}) => (
    <div className="shrink-0 mx-0">
        {/* Film Strip Container */}
        <div className="bg-zinc-950 py-2.5 px-1 rounded-sm shadow-md flex flex-col gap-1 mx-3">
            {/* Perforations Top */}
            <div className="flex justify-between px-1.5 mb-1.5 gap-2">
                {[...Array(8)].map((_, i) => (
                    <div key={`top-${i}`} className="w-3.5 h-2.5 bg-white/8 rounded-[1.5px]"/>
                ))}
            </div>

            {/* Frame Content */}
            <div className="w-56 h-32 bg-zinc-900/80 border border-zinc-800/80 relative overflow-hidden flex items-center justify-center p-5 text-center">
                <div className="absolute inset-0 bg-gradient-to-tr from-white/[0.03] to-transparent pointer-events-none"/>
                <span className="text-zinc-400 text-sm font-medium leading-relaxed tracking-wide">
                    {text}
                </span>
            </div>

            {/* Perforations Bottom */}
            <div className="flex justify-between px-1.5 mt-1.5 gap-2">
                {[...Array(8)].map((_, i) => (
                    <div key={`bottom-${i}`} className="w-3.5 h-2.5 bg-white/8 rounded-[1.5px]"/>
                ))}
            </div>
        </div>
    </div>
);

const CinematicLoader = () => {
    const items = [...PHRASES, ...PHRASES];

    return (
        <div className="w-full overflow-hidden py-8 relative select-none pointer-events-none">
            {/* Gradient Masks — smooth fade to card background */}
            <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-white from-10% to-transparent z-10"/>
            <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-white from-10% to-transparent z-10"/>

            {/* Moving Strip */}
            <motion.div
                className="flex items-center w-max"
                animate={{
                    x: ["0%", "-50%"]
                }}
                transition={{
                    duration: 60,
                    ease: "linear",
                    repeat: Infinity,
                    repeatType: "loop"
                }}
            >
                {items.map((phrase, idx) => (
                    <FilmFrame key={`${idx}-${phrase}`} text={phrase}/>
                ))}
            </motion.div>
        </div>
    );
};

export default CinematicLoader;
